export var ValidacaoModulo;
(function (ValidacaoModulo) {
    ValidacaoModulo["PARAMETRO"] = "PARAMETRO";
    ValidacaoModulo["ENSAIO"] = "ENSAIO";
    ValidacaoModulo["EQUIPAMENTO"] = "EQUIPAMENTO";
})(ValidacaoModulo || (ValidacaoModulo = {}));
